import LdsButton from '../LdsButton/index.jsx';
import LdsSelect from '../LdsSelect/index.jsx';

import {
  getMonthOptions
} from './datepicker.helpers.js';

export default function CalendarControls({
  translation,
  handleMonthBack,
  handleMonthForward,
  setFocusedCalendarButton,
  selectedMonth,
  setSelectedMonth,
  selectedYear,
  setSelectedYear,
}) {
  const monthOptions = getMonthOptions(translation);

  const handleYearInputChange = (e) => {
    const value = e.target.value;
    if (value.length <= 4) {
      setSelectedYear(value);
    }
  };

  const handleCalendarKeyDown = (e) => {
    const isNumber = isFinite(e.key);
    const isBackspace = e.key === 'Backspace';
    const isArrowKey = e.key.includes('Arrow');
    const isDeleteKey = e.key === 'Delete';
    const isTabKey = e.key === 'Tab';
    if (
      !isNumber
      && !isBackspace
      && !isArrowKey
      && !isDeleteKey
      && !isTabKey
    ) e.preventDefault();
  };

  return (
    <div className="date-selection">
      <LdsButton
        classes="compact calendar-arrow"
        icon="CaretLeft"
        onClick={handleMonthBack}
        aria-label={translation.previousMonthButtonAriaLabel}
        iconOnly
      ></LdsButton>
      <LdsSelect
        id="calendarMonth"
        name="calendarMonth"
        classes="date-input month"
        options={monthOptions}
        value={selectedMonth}
        onChange={(option) => setSelectedMonth(option.value)}
        buttonProps={{
          onFocus: () => setFocusedCalendarButton(null),
          'aria-label': translation.selectMonthDropdownAriaLabel,
        }}
      ></LdsSelect>
      <input
        id="calendarYear"
        name="calendarYear"
        className="date-input year"
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={selectedYear}
        onChange={handleYearInputChange}
        maxLength="4"
        minLength="4"
        onFocus={() => setFocusedCalendarButton(null)}
        aria-label={translation.inputYearAriaLabel}
        onKeyDown={handleCalendarKeyDown}
      />
      <LdsButton
        classes="compact calendar-arrow"
        icon="CaretRight"
        onClick={handleMonthForward}
        aria-label={translation.nextMonthButtonAriaLabel}
        iconOnly
      ></LdsButton>
    </div>
  );
}
